<template>
  <div style="max-width: 960px; margin: 0 auto">
    <BackButton link="/partners" text="Back to Service partner profiles" />
    <DashboardHeader :heading="`Invitation to ${invitation.name}`" />
    <SectionHeading
      heading="Invitation details"
      description="An invitation to join your directory was sent to the following partner and they have yet to accept and create their profile."
    />
    <Card v-if="invitation">
      <div class="grid">
        <div
          class="grid__cell col4-of-12--large-up mb-lg"
          v-for="(item, index) in descriptionListItems"
          :key="index"
        >
          <DescriptionListItem
            :title="item.title"
            :description="item.description"
          />
        </div>
      </div>
    </Card>
    <div class="flex justify-between mt-8">
      <Button @button-click="showModal = true" type="button" bType="error">
        Delete Invite
      </Button>
      <Button @button-click="resendInvite" type="button">
        Resend Invite
      </Button>
    </div>
    <Modal
      v-if="showModal"
      :modalShowing="showModal"
      okText="Delete"
      cancelText="Close"
      header="Delete invitation?"
      body="This action can't be undone, do you want to continue?"
      @cancel="showModal = false"
      @confirm="deleteInvite"
    />
  </div>
</template>

<script>
import { formatDate } from '@/utils/date';
import Modal from '@/components/Modal';
import BackButton from '@/components/BackButton';
import Button from '@/components/DesignSystem/Button';
import Card from '@/components/DesignSystem/Card';
import DashboardHeader from '@/components/Dashboard/DashboardHeader';
import DescriptionListItem from '@/components/DescriptionListItem';
import SectionHeading from '@/components/DesignSystem/SectionHeading';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers(
  'agencyProfiles/agencyInvitation'
);

export default {
  name: 'InviteDetailPage',
  components: {
    Button,
    Card,
    BackButton,
    Modal,
    DashboardHeader,
    SectionHeading,
    DescriptionListItem,
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    ...mapGetters({
      invitation: 'getInvitation',
    }),
    descriptionListItems() {
      return [
        {
          title: 'Invitation sent date',
          description: formatDate(new Date(this.invitation.created)),
        },
        {
          title: 'Partner name',
          description: this.invitation.name,
        },
        {
          title: 'Contact person',
          description: this.invitation.inviteName,
        },
        {
          title: 'Email address',
          description: this.invitation.email,
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      'fetchInvitationData',
      'deleteInvitation',
      'resendPartnerInvite',
    ]),
    deleteInvite() {
      this.deleteInvitation(this.$route.params.id);
    },
    resendInvite() {
      this.resendPartnerInvite(this.invitation.email);
    },
  },
  created() {
    this.fetchInvitationData(this.$route.params.id);
  },
};
</script>
